import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import Select from "react-select";
import CustomSelect from "../../../../components/Common/CustomSelect";

const CampaignAdvertisingAccountModal = props => {
  const {
    isOpen,
    toggle,
    data,
    addCampaignAdvertisingAccount,
    updateCampaignAdvertisingAccountProfile,
    editData,
    customer_data,
  } = props;

  const [cashbacks, setCashbacks] = useState(
    (props.cashbacks.results || props.cashbacks).map(item => {
      return {
        label: item.name,
        value: item.id,
      };
    })
  );

  const sources = (props.adPlatforms?.results || props.adPlatforms).map(
    item => {
      return {
        label: item.name,
        value: item.id,
      };
    }
  );

  const platformData = customer_data;

  const [name, setName] = useState();
  const [customName, setCustomName] = useState();
  const [selectedCashbacks, setSelectedCashbacks] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState({});
  const [isSubmitForm, setIsSubmitForm] = useState(false);

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      cashbacks.map(item => {
        for (let i in editData.cashbacks) {
          if (item.value === editData.cashbacks[i]) {
            selectedCashbacks.push(item);
          }
        }
      });
      let platforms = [];
      for (let [key, _] of Object.entries(customer_data)) {
        platforms.push({ label: key, value: key });
      }
      let pl = sources.find(pl => pl.label === editData.ad_platform);
      let idx = customer_data[pl?.label].findIndex(
        i => i?.id == editData?.platform_cabinet_id
      );

      let cb = [];
      (props.cashbacks.results || props.cashbacks).map(i => {
        if (i.media_source_name == pl.label) {
          cb.push({
            label: i.name,
            value: i.id,
          });
        }
      });

      setCashbacks(cb);
      setName({
        label: customer_data[pl?.label][idx]?.name,
        value: customer_data[pl?.label][idx]?.id,
      });
      setSelectedPlatform(pl);
      if (editData?.custom_name !== null) {
        setCustomName(editData.custom_name);
      }
    } else {
      setSelectedCashbacks([]);
      setSelectedPlatform("");
      setCustomName("")
    }
  }, [isOpen]);

  const handleValidOrderSubmit = (e, errors, params) => {
    setIsSubmitForm(true);
    if (errors?.length === 0) {
      if (editData !== null) {
        updateCampaignAdvertisingAccountProfile(
          editData.id,
          {
            ...params,
            name: params.name?.label,
            ad_platform: params.ad_platform?.value,
            cashbacks: selectedCashbacks.map(item => item.value),
            ...(customName && { custom_name: customName }),
          },
          data
        );
        toggle();
      } else {
        addCampaignAdvertisingAccount(
          {
            ...params,
            name: params.name?.label,
            ad_platform: params.ad_platform?.value,
            cashbacks: selectedCashbacks.map(item => item.value),
            ...(customName && { custom_name: customName }),
          },
          data
        );
        toggle();
      }
    }
  };

  const onSetSelectedPlatform = v => {
    if (selectedPlatform.value != v.value) {
      let cb = [];
      (props.cashbacks.results || props.cashbacks).map(i => {
        if (i.media_source_name == v.label) {
          cb.push({
            label: i.name,
            value: i.id,
          });
        }
      });

      setCashbacks(cb);
      setSelectedPlatform(v);
      setName();
      setSelectedCashbacks([]);
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus centered toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} campaign advertising account
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Ad account platform</Label>
                <CustomSelect
                  name="ad_platform"
                  defaultValue={selectedPlatform}
                  options={sources}
                  onChange={onSetSelectedPlatform}
                  classNamePrefix="select2-selection"
                  errorMessage="Ad account platform is required"
                  isFormSubmit={isSubmitForm}
                  required
                />
              </div>
              <div className="mb-3">
                <Label>Ad account name</Label>
                <CustomSelect
                  name="name"
                  defaultValue={name}
                  options={
                    selectedPlatform?.value
                      ? platformData[selectedPlatform?.label]?.map(i => {
                          return {
                            label: i.name,
                            value: i.id,
                          };
                        })
                      : []
                  }
                  isDisabled={!selectedPlatform?.value}
                  onChange={setName}
                  classNamePrefix="select2-selection"
                  errorMessage="Ad account platform name is required"
                  isFormSubmit={isSubmitForm}
                  required
                />
              </div>
              {selectedPlatform?.label == 'Unity' && (
                <div className="mb-3">
                  <Label>Custom name</Label>
                  <AvField
                    name="custom_name"
                    type="text"
                    value={customName || ""}
                    placeholder="Custom name..."
                    onChange={(e) => setCustomName(e.target.value)}
                  />
                </div>
              )}
              <div className="mb-3">
                <Label>Ad account platform id</Label>
                <AvField
                  name="platform_cabinet_id"
                  type="text"
                  errorMessage="This value is required."
                  value={name?.value || ""}
                  placeholder="Ad account platform id..."
                  disabled
                  // validate={{
                  //   required: { value: true },
                  //   maxLength: {
                  //     value: 150,
                  //     errorMessage: "Max 150 characters.",
                  //   },
                  //   minLength: { value: 1, errorMessage: "Min 1 character" },
                  // }}
                />
              </div>
              <div className="mb-3">
                <Label>Cashbacks</Label>
                <Select
                  name="cashbacks"
                  options={cashbacks}
                  value={selectedCashbacks}
                  onChange={setSelectedCashbacks}
                  isMulti={true}
                  isSearchable={true}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_campaigncabinetmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CampaignAdvertisingAccountModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  cashbacks: PropTypes.any,
  adPlatforms: PropTypes.any,
  addCampaignAdvertisingAccount: PropTypes.func,
  updateCampaignAdvertisingAccountProfile: PropTypes.func,
  customer_data: PropTypes.object,
  editData: PropTypes.any,
  permissions: PropTypes.any,
  getCampaignCashbacksList: PropTypes.func,
};

export default CampaignAdvertisingAccountModal;
